import type { ZplPrintDocument } from "@/lib/zplPrintLocation";

/**
 * ZPL jobs the Outbound page can send. The shared location widget matches
 * online printers to these rows and shows "All" or the covered names.
 * Office PDFs (packing slip, freight documents) use the letter printer, not this list.
 */
export const OUTBOUND_ZPL_DOCUMENTS: readonly ZplPrintDocument[] = [
  { id: "carton", label: "Carton", labelSize: "4x6", dpi: 203 },
  { id: "ups", label: "UPS", labelSize: "4x6", dpi: 203 },
];
